import client from '@/api/client'

export async function getAchieveState() {
    return client.get(`/mlp-achieve/achieve-state`)
}
